(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.vi = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'Hiện tại',
        today: 'Hôm nay',
        cancel: 'Hủy',
        clear: 'Xóa',
        confirm: 'OK',
        selectDate: 'Chọn ngày',
        selectTime: 'Chọn giờ',
        startDate: 'Ngày bắt đầu',
        startTime: 'Thời gian bắt đầu',
        endDate: 'Ngày kết thúc',
        endTime: 'Thời gian kết thúc',
        prevYear: 'Previous Year',
        // to be translated
        nextYear: 'Next Year',
        // to be translated
        prevMonth: 'Previous Month',
        // to be translated
        nextMonth: 'Next Month',
        // to be translated
        year: 'Năm',
        month1: 'Tháng 1',
        month2: 'Tháng 2',
        month3: 'Tháng 3',
        month4: 'Tháng 4',
        month5: 'Tháng 5',
        month6: 'Tháng 6',
        month7: 'Tháng 7',
        month8: 'Tháng 8',
        month9: 'Tháng 9',
        month10: 'Tháng 10',
        month11: 'Tháng 11',
        month12: 'Tháng 12',
        weeks: {
          sun: 'CN',
          mon: 'T2',
          tue: 'T3',
          wed: 'T4',
          thu: 'T5',
          fri: 'T6',
          sat: 'T7'
        },
        months: {
          jan: 'Th.1',
          feb: 'Th.2',
          mar: 'Th.3',
          apr: 'Th.4',
          may: 'Th.5',
          jun: 'Th.6',
          jul: 'Th.7',
          aug: 'Th.8',
          sep: 'Th.9',
          oct: 'Th.10',
          nov: 'Th.11',
          dec: 'Th.12'
        },
        pickADay: 'Select a day'
      },
      select: {
        loading: 'Đang tải',
        noMatch: 'Dữ liệu không phù hợp',
        noData: 'Không tìm thấy dữ liệu',
        placeholder: 'Chọn'
      },
      pagination: {
        goto: 'Nhảy tới',
        pagesize: '/trang',
        total: 'Tổng {total}',
        pageClassifier: ''
      },
      upload: {
        deleteTip: 'press delete to remove',
        // to be translated
        delete: 'Xóa',
        preview: 'Xem trước',
        continue: 'Tiếp tục'
      },
      table: {
        emptyText: 'Không có dữ liệu',
        confirmFilter: 'Xác nhận',
        resetFilter: 'Làm mới',
        clearFilter: 'Xóa hết',
        sumText: 'Tổng'
      },
      tree: {
        emptyText: 'Không có dữ liệu'
      }
    }
  };
  _exports.default = _default;
});